<script setup lang="ts">
import { localizeUrl } from '@shared/fondof-fn/url/localize'

import { StorefinderIcon } from '@fond-of/satch-icons'

const props = defineProps<{
  href?: string
  label?: string
}>()
</script>

<template>
  <a
    v-if="props.href"
    :href="localizeUrl(`/${props.href}`)"
    class="relative flex h-[22px] w-[22px] cursor-pointer items-center space-x-1 lg:h-auto lg:w-auto"
  >
    <span class="block">
      <StorefinderIcon
        class="lg:text-gray-icon hidden text-black lg:block lg:h-4 lg:w-4"
        viewBox="0 0 22 22"
      />
    </span>

    <span class="text-nav text-gray-topnav hidden pt-0.5 lg:block">
      {{ props.label }}
    </span>
  </a>
</template>
